export enum ActionTypes {
  REQUEST = "@feriados/REQUEST",
  SUCCESS = "@feriados/SUCCESS",
  FAILURE = "@feriados/FAILURE",
}
